interface SecureRandomSource {
  readonly getRandomValues?: (values: Uint8Array<ArrayBuffer>) => Uint8Array<ArrayBuffer>;
  readonly randomUUID?: () => string;
}

/** Plain HTTP LAN previews expose getRandomValues even when randomUUID is unavailable. */
export const createRequestId = (source: SecureRandomSource | undefined = globalThis.crypto): string => {
  if(typeof source?.randomUUID === 'function') {
    return source.randomUUID();
  }
  if(typeof source?.getRandomValues !== 'function') {
    throw new Error('This browser cannot create a secure generation request ID. Use a current browser.');
  }
  const bytes = source.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
